const _window: Window | undefined =
  typeof window === "undefined" ? undefined : window;

const _navigator: Navigator | undefined =
  typeof navigator === "undefined" ? undefined : navigator;

let _localStorage: Storage | undefined = undefined;
try {
  _localStorage = _window?.localStorage;
} catch {}

export {
  _window as window,
  _localStorage as localStorage,
  _navigator as navigator,
};
